import React from "react";
import AppModal from "../app-modal";
import FormDropdown from "../../../base/form-dropdown";
import PostRecordUpdateModalDomain from "./domain";
import { NotificationManager } from "react-notifications";
import { isFunction } from "@utils";

const { handleupdatePostRecord } = PostRecordUpdateModalDomain;

const PostRecordUpdateModal = ({
  showModal,
  postId,
  fieldName,
  type,
  title,
  fieldLabel,
  options = [],
  currentValue,
  closeModal,
  refreshAdData,
}) => {
  const [newValue, setNewValue] = React.useState();

  const handleChange = (e) => {
    setNewValue(e?.target?.value);
  };

  const updateNewValue = async () => {
    try {
      await handleupdatePostRecord({ fieldName, value: newValue, postId });
      if (isFunction(refreshAdData)) {
        refreshAdData();
      }
      if (isFunction(closeModal)) {
        closeModal();
      }
      NotificationManager.success("Post updated");
    } catch (error) {
      NotificationManager.error("Unknown Error Occurred");
      console.log(error);
    }
  };

  return (
    <AppModal
      visibility={showModal}
      title={title}
      onPrimaryAction={updateNewValue}
      onSecondaryAction={closeModal}
      handleClose={closeModal}
    >
      {type === "SELECT" && (
        <FormDropdown
          label={fieldLabel}
          options={options}
          value={newValue ?? currentValue}
          onChangeValue={handleChange}
        />
      )}
    </AppModal>
  );
};

export default PostRecordUpdateModal;
